export default function Dashboard({ domains, sales }) {
  const totalInvested = domains.reduce((s, d) => s + (d.cost || 0) + (d.renewals || []).reduce((rs, r) => rs + r.cost, 0), 0);
  const totalSaleRevenue = sales.reduce((s, d) => s + d.price, 0);
  const totalSaleCost = sales.reduce((s, d) => s + d.cost, 0);
  const profit = totalSaleRevenue - totalSaleCost;
  const active = domains.filter((d) => d.status === "معروض").length;

  const expiringSoon = domains.filter((d) => {
    if (!d.expiry) return false;
    const days = Math.ceil((new Date(d.expiry) - new Date()) / 86400000);
    return days <= 60 && days > 0;
  });

  const expired = domains.filter((d) => {
    if (!d.expiry) return false;
    return Math.ceil((new Date(d.expiry) - new Date()) / 86400000) <= 0;
  });

  const stats = [
    { label: "إجمالي الدومينات", value: domains.length, icon: "◈", color: "#c8a96e" },
    { label: "إجمالي الاستثمار", value: `$${totalInvested.toFixed(0)}`, icon: "◆", color: "#7c9cba" },
    { label: "معروضة للبيع", value: active, icon: "◉", color: "#8bc4a8" },
    { label: "صافي الأرباح", value: `$${profit.toFixed(0)}`, icon: "▲", color: profit >= 0 ? "#8bc4a8" : "#c47c7c" },
  ];

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 14, marginBottom: 28 }}>
        {stats.map((s) => (
          <div key={s.label} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 16, padding: "18px 14px", textAlign: "center" }}>
            <div style={{ fontSize: 24, marginBottom: 6, color: s.color }}>{s.icon}</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: s.color, marginBottom: 4 }}>{s.value}</div>
            <div style={{ fontSize: 11, color: "#666", letterSpacing: 0.5 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {expired.length > 0 && (
        <div style={{ background: "rgba(196,124,124,0.1)", border: "1px solid rgba(196,124,124,0.35)", borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ color: "#c47c7c", fontWeight: 700, marginBottom: 10, fontSize: 13 }}>🚨 دومينات منتهية الصلاحية</div>
          {expired.map((d) => (
            <div key={d.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.05)", fontSize: 13 }}>
              <span style={{ color: "#ddd", direction: "ltr" }}>{d.name}</span>
              <span style={{ color: "#c47c7c" }}>منتهي ⚠️</span>
            </div>
          ))}
        </div>
      )}

      {expiringSoon.length > 0 && (
        <div style={{ background: "rgba(200,169,110,0.08)", border: "1px solid rgba(200,169,110,0.25)", borderRadius: 12, padding: 16, marginBottom: 20 }}>
          <div style={{ color: "#c8a96e", fontWeight: 700, marginBottom: 10, fontSize: 13 }}>⏰ تنتهي خلال 60 يوم</div>
          {expiringSoon.map((d) => {
            const days = Math.ceil((new Date(d.expiry) - new Date()) / 86400000);
            return (
              <div key={d.id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.05)", fontSize: 13 }}>
                <span style={{ color: "#ddd", direction: "ltr" }}>{d.name}</span>
                <span style={{ color: "#c8a96e" }}>بعد {days} يوم</span>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 14, padding: 18 }}>
        <div style={{ color: "#c8a96e", fontWeight: 700, marginBottom: 14, fontSize: 13, letterSpacing: 1 }}>روابط سريعة</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {[["NameBio.com","#0891b2"],["NamePros.com","#dc2626"],["Afternic.com","#ff6900"],["Sedo.com","#0066cc"]].map(([l, c]) => (
            <a key={l} href={`https://${l}`} target="_blank" rel="noreferrer"
              style={{ background: `${c}15`, border: `1px solid ${c}40`, borderRadius: 8, padding: "10px", color: c, textDecoration: "none", fontSize: 12, textAlign: "center", display: "block" }}>
              {l}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
